import globalConfig from 'app/fuse-configs/globalConfig'
import React from 'react'
import { Redirect } from 'react-router'

const ProvidersConfig = {
	settings: {
		layout: {
			config: {
				...globalConfig
			}
		}
	},
	auth: [1],
	routes: [
		{
			path: '/reports/project-specific',
			component: React.lazy(() => import('./ProvidersApp'))
		},
		{
			path: '/reports',
			exact: true,
			component: () => <Redirect to="/reports/project-specific" />
		}
	]
}

export default ProvidersConfig
